import { useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import useAuth from "src/hooks/useAuth";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";

const ChatAccept = ({
    user,
    actionPhase,
    actionState,
    changeActionState
}) => {
    const { cliente } = useAuth();
    const [selectedPipe, setSelectedPipe] = useState(null);
    const [selectedPhase, setSelectedPhase] = useState(null); // Use null instead of an empty string
    const [configCrm, setConfigCrm] = useState(null);
    const [users, setUsers] = useState([]);

    let usersFormatted = users?.map((user) => {
        return {
          value: user._id,
          label: user.nomeFantasia
        }
        });

    async function getUsers() {
      try {
        const response = await getActionListaUsuariosByClienteId(user?.clienteId);
        setUsers(response.data.usuarios);
  
      } catch (error) {
        console.log(error);
      }
    }
  
    useEffect(() => {
      getUsers();
    }, []);
  


    return (
        <Card className="w-full">
            <CardHeader>
            <LabelFromAction>
          {actionPhase.name}
        </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                <MultiSelect
                    options={usersFormatted}
                    onValueChange={(e) => {
                      console.log(e);
                      let event = {
                        name: "chatUsersAccept",
                        value: e
                      }
                      changeActionState(event);
                    }}
                    defaultValue={actionState?.chatUsersAccept}
                    placeholder="Selecionar usuarios"
                    variant="inverted"
                    animation={2}
                    maxCount={3}
                  />
                </div>
            </CardContent>
        </Card>
    );
};

export default ChatAccept;
